/**
 * BenchmarkCurveName
 * - Tag: 221
 * - FIX Specification type: String
 * - Mapped type: string
 * @readonly
 * @public
 */
export const BenchmarkCurveName = Object.freeze({
    /** EONIA */
    EONIA: 'EONIA',
    /** EUREPO */
    EUREPO: 'EUREPO',
    Euribor: 'Euribor',
    /** FutureSWAP */
    FutureSWAP: 'FutureSWAP',
    /** LIBID */
    LIBID: 'LIBID',
    /** LIBOR (London Inter-Bank Offer) */
    LIBOR: 'LIBOR',
    /** MuniAAA */
    MuniAAA: 'MuniAAA',
    /** OTHER */
    OTHER: 'OTHER',
    /** Pfandbriefe */
    Pfandbriefe: 'Pfandbriefe',
    /** SONIA */
    SONIA: 'SONIA',
    /** SWAP */
    SWAP: 'SWAP',
    /** Treasury */
    Treasury: 'Treasury',
    FedFundRateEffective: 'FEDEFF',
    FedOpen: 'FEDOPEN',
    /** Euro interbank offer rate */
    EURIBOR: 'EURIBOR',
    /** Australian Bank Bill Swap Rate */
    AUBSW: 'AUBSW',
    /** Budapest Bank Offered Rate */
    BUBOR: 'BUBOR',
    /** Canadian Dollar Offered Rate */
    CDOR: 'CDOR',
    /** Copenhagen Interbank Offered Rate */
    CIBOR: 'CIBOR',
    /** Euro Overnight Index Average Swap Rate */
    EONIASWAP: 'EONIASWAP',
    ESTR: 'ESTR',
    /** Euro Dollar Rate */
    EURODOLLAR: 'EURODOLLAR',
    /** Euro Swiss Franc Rate */
    EUROSWISS: 'EUROSWISS',
    /** DTCC General Collateral Finance Repo Index */
    GCFREPO: 'GCFREPO',
    /** ICE Swap Rate */
    ISDAFIX: 'ISDAFIX',
    /** Johannesburg Interbank Agreed Rate */
    JIBAR: 'JIBAR',
    /** Moscow Prime Offered Rate */
    MOSPRIM: 'MOSPRIM',
    /** Nigeria Three Month Interbank Rate */
    NIBOR: 'NIBOR',
    /** Czech Republic Interbank Offered Rate */
    PRIBOR: 'PRIBOR',
    SOFR: 'SOFR',
    /** Stockholm Interbank Offered Rate */
    STIBOR: 'STIBOR',
    /** Bank of Israel Interbank Offered Rate */
    TELBOR: 'TELBOR',
    /** Tokyo Interbank Offered Rate */
    TIBOR: 'TIBOR',
    /** Warsaw Interbank Offered Rate */
    WIBOR: 'WIBOR',
    AONIA: 'AONIA',
    AONIAR: 'AONIA-R',
    /** New Zealand Bank Bill Market Rate */
    BKBM: 'BKBM',
    /** Republic of Korea 90-Day Certificate of Deposit Rate */
    CD19D: 'CD91D',
    /** Canadian Overnight Repo Rate Average */
    CORRA: 'CORRA',
    /** Danish Interbank Interest Rate-Tomorrow or Next */
    DIRRTN: 'DIRR-TN',
    /** Emirates Interbank Offered Rate */
    EIBOR: 'EIBOR',
    /** China Interbank Overnight Repo Rate */
    FixingRepoRate: 'FixingRepoRate',
    /** Hong Kong Interbank Offered Rate */
    HIBOR: 'HIBOR',
    /** Colombia Overnight Interbank Reference Rate */
    IBR: 'IBR',
    /** Kuala Lumpur Interbank Offered Rate */
    KLIBOR: 'KLIBOR',
    /** Mumbia Interbank Offered Rate */
    MIBOR: 'MIBOR',
    /** New Zealand Overnight Indexed Swaps (OIS) */
    NZONIA: 'NZONIA',
    /** Philippines Interbank Reference Rate */
    PHIREF: 'PHIREF',
    /** Reykjavik Interbank Offered Rate */
    REIBOR: 'REIBOR',
    /** Saudi Arabian Interbank Offered Rate */
    SAIBOR: 'SAIBOR',
    /** Swiss Average Rate Overnight */
    SARON: 'SARON',
    /** Singapore Swap Offer Rate */
    SORA: 'SORA',
    /** Turkish Lira Overnight Reference Rate */
    TLREF: 'TLREF',
    /** Mexico Interbank Equilibrium Interest Rate */
    TIIE: 'TIIE',
    /** Thai Baht Interest Rate Fixing */
    THBFIX: 'THBFIX',
    /** Tokyo Overnight Average Rate */
    TONAR: 'TONAR',
} as const);

type BenchmarkCurveName = (typeof BenchmarkCurveName)[keyof typeof BenchmarkCurveName];
